import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PropertyBoundaryForm from '../components/PropertyBoundaryForm';
import './SetupRancher.css';

function SetupRancher() {
  const navigate   = useNavigate();
  const [showForm, setShowForm] = useState(false);

  const handleSave = (property) => {
    navigate('/setup/rancher/features', { state: { property } });
  };

  return (
    <div className="setup-rancher-page">
      <div className="setup-rancher-container">

        <div className="setup-rancher-header">
          <h1>Set Up Your Property</h1>
          <p>Add a ranch or farm.</p>
        </div>


          <PropertyBoundaryForm
            stepLabel="Step 1 of 2"
            saveLabel="Save Property"
            cancelLabel="Cancel"
            onSave={handleSave}
            onCancel={() => navigate('/dashboard')}
          />
        

      </div>
    </div>
  );
}

export default SetupRancher;


